import React, { PropsWithChildren, useEffect } from 'react';

import {
  mobileDrawerStoreSelector,
  useMobileDrawerStore,
} from '@editor/stores/mobileDrawerStore';
import {
  Drawer,
  DrawerSnapPoints,
} from '@repo/ui-kit/components/modules/Drawer';

type Props = {
  isOpen: boolean;
  onClose: (() => void) | undefined;
};

/**
 * Mounts the upgrade flow (revamped) modal on mobile.
 */
export const RevampedCheckoutFlowMobile: React.FC<PropsWithChildren<Props>> = ({
  children,
  isOpen,
  onClose,
}) => {
  const setIsOpen = useMobileDrawerStore(mobileDrawerStoreSelector.setIsOpen);

  useEffect(() => {
    if (isOpen) {
      // Close the mobile drawer when the checkoutflow is launched
      setIsOpen(false);
    }
  }, [isOpen, setIsOpen]);

  return (
    <Drawer.Root
      modal
      defaultSnapPoint={DrawerSnapPoints.FULL_OPENED}
      enableBackgroundScrolling={false}
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) {
          onClose?.();
        }
      }}
    >
      <Drawer.Content>
        <Drawer.Header />
        {children}
      </Drawer.Content>
    </Drawer.Root>
  );
};
